import React, { useEffect, useRef, useState } from "react";
import { fetchMessageTypes } from "../../hooks/fetchMessageTypes ";
import { fetchInitiatedByList } from "../../hooks/fetchInitiatedByList";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import ModalStudent from "./ModalStudent";
import useFetchClasses from "../../hooks/useFetchClasses";
import useFetchSections from "../../hooks/useFetchSections";
import { ApiUrl } from "../../../ApiUrl";
import Select from "react-select";
import ReactPaginate from "react-paginate";

const AdmAttendanceEntry = () => {
  const todayDate = new Date().toISOString().split("T")[0];
  const [showModal, setShowModal] = useState(false);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [selectedStudentName, setSelectedStudentName] = useState("");
  const [data, setData] = useState([]);
  const [messageTypes, setMessageTypes] = useState([]);
  const [initiatedByList, setInitiatedByList] = useState([]);
  //New Added Usestate
  const [selectedMessageType, setSelectedMessageType] = useState(null);
  const [selectedInitiatedBy, setSelectedInitiatedBy] = useState(null);

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const navigate = useNavigate();
  const {
    classes,
    loading: classesLoading,
    error: classesError,
  } = useFetchClasses();
  const {
    sections,
    loading: sectionsLoading,
    error: sectionsError,
  } = useFetchSections(selectedClass);
  const handleOpenModal = () => {
    setShowModal(true);
  };
  const handleNewMessage = () => {
    navigate("/admstudentmessagelist");
  };

  const dateFromRef = useRef(null);
  const dateToRef = useRef(null);
  const messageTypeRef = useRef(null);
  const studentNameRef = useRef(null);
  const initiatedByRef = useRef(null);
  const [isInputDisabled, setIsInputDisabled] = useState(true);

  const [currentPage, setCurrentPage] = useState(0);
  const rowsPerPage = 10;

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const offset = currentPage * rowsPerPage;
  const currentRows = data.slice(offset, offset + rowsPerPage);
  const pageCount = Math.ceil(data.length / rowsPerPage);

  useEffect(() => {
    const loadMessageTypes = async () => {
      const types = await fetchMessageTypes();
      setMessageTypes(types);
    };
    const loadInitiatedByOptions = async () => {
      const list = await fetchInitiatedByList();
      setInitiatedByList(list);
    };
    loadMessageTypes();
    loadInitiatedByOptions();
  }, []);

  const classOptions = classes.map((classItem) => ({
    value: classItem.id,
    label: classItem.classname,
  }));

  // Handle selection
  const handleClassChange = (selectedOption) => {
    const classId = selectedOption?.value || "";
    setSelectedClass(classId);
    localStorage.setItem("selectedMessageClass", classId);
    setSelectedSection("");
  };

  // const sectionOptions = sections.map((section) => ({
  //   value: section.id,
  //   label: section.sectionname,
  // }));

  const sectionOptions = sections.map((section) => ({
    value: section.section_id,  // ✅ use section_id instead of id
    label: section.sectionname,
  }));

  // Handle section change
  const handleSectionChange = (selectedOption) => {
    const sectionId = selectedOption?.value || "";
    setSelectedSection(sectionId);
    localStorage.setItem("selectedMessageSection", sectionId);
  };
  const handleMessageTypeChange = (selectedOption) => {
    setSelectedMessageType(selectedOption); // NEW
    const selectedMessageId = selectedOption?.value || "";
    localStorage.setItem("selectedMessageTypeId", selectedMessageId);
  };

  const messageTypeOptions = messageTypes.map((type) => ({
    value: type.id,
    label: type.messageType_desc,
  }));
  const initiatedByOptions = initiatedByList.map((item) => ({
    value: item.id,
    label: item.InitiatedBy_desc,
  }));

  // Handle change for Initiated Select
  const handleInitiatedByChange = (selectedOption) => {
    setSelectedInitiatedBy(selectedOption); // NEW
    const selectedId = selectedOption?.value || "";
    localStorage.setItem("selectedInitiatedById", selectedId);
  };

  const handleSelectStudent = (student) => {

    const {
      first_name,
      middle_name = "",
      last_name,
    } = student.studentBasicDetails;
    const fullName = `${first_name} ${middle_name} ${last_name}`.trim();
    setSelectedStudentName(fullName);

    if (studentNameRef.current) {
      studentNameRef.current.value = fullName;
    }


    handleCloseModal();
  };

  const handleSearch = async () => {
    const academicYearId = localStorage.getItem("academicSessionId");
    const classId = localStorage.getItem("selectedMessageClass") || "";
    const sectionId = localStorage.getItem("selectedMessageSection") || "";
    const messageType = localStorage.getItem("selectedMessageTypeId") || "";
    const initiatedBy = localStorage.getItem("selectedInitiatedById") || "";
    const studentId = localStorage.getItem("selectedMessageStudentId") || "";
    const fromDate = dateFromRef.current?.value || "";
    const toDate = dateToRef.current?.value || "";

    const queryParams = new URLSearchParams();

    if (academicYearId) queryParams.append("academic_year_id", academicYearId);
    if (studentId) queryParams.append("studentId", studentId);
    if (initiatedBy) queryParams.append("initiatedBy", initiatedBy);
    if (messageType) queryParams.append("messagetype", messageType);
    if (classId) queryParams.append("classId", classId);
    if (sectionId) queryParams.append("sectionId", sectionId);
    if (fromDate) queryParams.append("fromdate", fromDate);
    if (toDate) queryParams.append("fromto", toDate);

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}MessageSEND/StudentMessageHistoryFilter/?${queryParams.toString()}`
      );
      const result = await response.json();

      console.log("API Response:", result);
      if (Array.isArray(result.data)) {
        setData(result.data);
      } else {
        console.error("Unexpected response format:", result);
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    }
  };

  const handleClear = () => {
    if (dateFromRef.current) dateFromRef.current.value = todayDate;
    if (dateToRef.current) dateToRef.current.value = todayDate;
    if (messageTypeRef.current) messageTypeRef.current.value = "";
    if (studentNameRef.current) studentNameRef.current.value = "";
    if (initiatedByRef.current) initiatedByRef.current.value = "";

    setSelectedClass("");
    setSelectedSection("");
    setSelectedStudentName("");
    setSelectedMessageType(null);       // NEW
    setSelectedInitiatedBy(null);       // NEW
    setData([]);
    localStorage.removeItem("selectedMessageTypeId");
    localStorage.removeItem("selectedMessageStudentId");
    localStorage.removeItem("selectedInitiatedById");
    localStorage.removeItem("selectedMessageClass");
    localStorage.removeItem("selectedMessageSection");
    console.log("Local storage keys cleared");
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT MESSAGE
              </p>
              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleNewMessage}
                  >
                    New Message
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                </div>
              </div>
              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 mt-2">
                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="message-type" className="form-label">
                          Message Type
                        </label>
                        <Select
                          inputId="message-type"
                          className="detail"
                          classNamePrefix="detail"
                          options={messageTypeOptions}
                          onChange={handleMessageTypeChange}
                          value={selectedMessageType}
                          placeholder="Select message type"
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-0">
                        <label htmlFor="student-name" className="form-label">
                          Student Name
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="student-name"
                            className="form-control detail"
                            placeholder="Enter student name"
                            ref={studentNameRef}
                            disabled={isInputDisabled}
                            value={selectedStudentName}
                          // readOnly
                          />
                          <button
                            type="button"
                            className="btn btn-primary ms-0 mb-0 mt-0"
                            onClick={handleOpenModal}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </button>
                        </div>
                      </div>
                      {/* </div> */}
                      <div className="col-12 col-md-3 mb-0">
                        <label htmlFor="from-class" className="form-label">
                          Initiated By
                        </label>
                        <Select
                          inputId="from-class"
                          className="detail"
                          classNamePrefix="detail"
                          options={initiatedByOptions}
                          onChange={handleInitiatedByChange}
                          value={selectedInitiatedBy} // NEW
                          placeholder="Select initiated by"
                        />
                      </div>
                      {/* <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="class" className="form-label">
                          Class
                        </label>
                        {classesLoading ? (
                          <p>Loading classes...</p>
                        ) : classesError ? (
                          <p>Error loading classes: {classesError}</p>
                        ) : (
                          <select
                            id="class"
                            className="detail"
                            onChange={handleClassChange}
                            value={selectedClass}
                          >
                            <option value="">Select Class</option>
                            {classes.map((classItem) => (
                              <option key={classItem.id} value={classItem.id}>
                                {classItem.classname}
                              </option>
                            ))}
                          </select>
                        )}
                      </div> */}

                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="class" className="form-label">
                          Class
                        </label>
                        <Select
                          inputId="class"
                          className="detail"
                          classNamePrefix="detail"
                          options={classOptions}
                          onChange={handleClassChange}
                          placeholder="Select Class"
                          value={
                            classOptions.find(
                              (option) => option.value === selectedClass
                            ) || null
                          }
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="section" className="form-label">
                          Section
                        </label>
                        <Select
                          inputId="section"
                          className="detail"
                          classNamePrefix="detail"
                          options={sectionOptions}
                          onChange={handleSectionChange}
                          placeholder="Select Section"
                          value={
                            sectionOptions.find(
                              (option) => option.value === selectedSection
                            ) || null
                          }
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="date-from" className="form-label">
                          Date From
                        </label>
                        <input
                          type="date"
                          id="date-from"
                          className="form-control detail"
                          ref={dateFromRef}
                          defaultValue={todayDate}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="date-to" className="form-label">
                          Date To
                        </label>
                        <input
                          type="date"
                          id="date-to"
                          className="form-control detail"
                          ref={dateToRef}
                          defaultValue={todayDate}
                        />
                      </div>

                      <ModalStudent
                        show={showModal}
                        handleClose={handleCloseModal}
                        onSelectStudent={handleSelectStudent}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="table-responsive">
                  <table className="table  table-bordered">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Class</th>
                        <th>Section</th>
                        <th>Roll No</th>
                        <th>Student Name</th>
                        <th>BarCode</th>
                        <th>Father Name</th>
                        <th>Message Type</th>
                        <th>Message Date</th>
                        <th>Initiated By</th>
                        <th>Initiated Remarks</th>
                        <th>Message</th>
                        {/* <th>Status</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {data.length > 0 ? (
                        currentRows.map((row, index) => (
                          <tr key={index}>
                            <td>{currentPage * rowsPerPage + index + 1}</td>
                            <td>{row.classname}</td>
                            <td>{row.sectionname}</td>
                            <td>{row.rollno}</td>
                            <td>{row.studentName}</td>
                            <td>{row.barcode}</td>
                            <td>{row.fatherName}</td>
                            <td>{row.messageType}</td>
                            <td>{row.message_date}</td>
                            <td>{row.InitiatedBy}</td>
                            <td>{row.initiated_remarks}</td>
                            <td>{row.message}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center">
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {data.length > rowsPerPage && (
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination justify-content-center mt-3"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
